import type { ProductCategory } from 'src/types/products';

import { useContext, createContext } from 'react';

import { useCollectionData } from 'src/hooks/useCollectionData';

import { COLLECTIONS } from 'src/lib/consts';

const ProductCategoriesContext = createContext<{
  data: ProductCategory[];
  loading: boolean;
  error: any;
}>({
  data: [],
  loading: false,
  error: null,
});

export function useProductCategories() {
  return useContext(ProductCategoriesContext);
}

export function ProductCategoriesProvider({ children }: { children: React.ReactNode }) {
  const value = useCollectionData<ProductCategory>({ collectionName: COLLECTIONS.item_category });

  return (
    <ProductCategoriesContext.Provider value={value}>{children}</ProductCategoriesContext.Provider>
  );
}
